// 全局注册组件
import Vue from 'vue'

import cHead from './header.vue';

Vue.component('cHead', cHead);



// WEBPACK FOOTER //
// ./src/components/index.js